import { useCallback, useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import GameModeContext from "./context/GameMode";
import GameScoreContext from "./context/GameScore";
import Gamemode from "./Gamemode";
import "./GameoverModal.css";
import "./Scoreboard.css";
import { localizations, getLanguage } from "./localization";

const GameoverModal = () => {
  const gameMode = useContext(GameModeContext);
  const gameScore = useContext(GameScoreContext);
  const [modal, setModal] = useState(false);
  const [dimensions, setDimensions] = useState({
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight,
  });

  const handleResize = () => {
    setDimensions({
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
    });
  };
  const link = document.getElementById("game-over");

  const reStart = useCallback(() => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          gameMode.actions.setGamemode(new Number(gameMode.state.gamemode));
          gameScore.actions.setGameScore(0);

          link.style.display = "none";
        },
        onError: function (error) {},
      },
    });
  }, [
    gameMode.actions,
    gameMode.state.gamemode,
    gameScore.actions,
    link.style,
  ]);
  const openModal = useCallback(() => {
    setModal(true);
  }, []);
  const closeModal = useCallback(() => {
    gameScore.actions.setGameScore(0);
    gameMode.actions.setGamemode(new Number(gameMode.state.gamemode));
    link.style.display = "none";
    setModal(false);
  }, [
    gameMode.actions,
    gameMode.state.gamemode,
    gameScore.actions,
    link.style,
  ]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return ReactDOM.createPortal(
    <div
      className="container-game-over"
      style={(() => {
        var width = dimensions.w;
        var height = dimensions.h;
        var ratio = (height / width).toFixed(1);
        var scale;
        if (ratio <= 1.6) {
          scale = height / 900;
        } else {
          scale = width / 700;
        }
        return { transform: "scale(".concat(scale, ")") };
      })()}
    >
      <div className="block-modal">
        <div className="block-modal-wrapper">
          <div className="block-modal-title">
            {localizations.gameOverTitle[getLanguage()]}
          </div>
          <div className="block-modal-description">
            {localizations.score[getLanguage()]}: {gameScore.state.gameScore}
          </div>
          <button className="block-modal-button" onClick={reStart}>
            {localizations.restart[getLanguage()]}
          </button>
          <button className="block-modal-button" onClick={openModal}>
            {localizations.chooseSize[getLanguage()]}
          </button>
        </div>
        {modal && (
          <div className="block-modal">
            <div className="block-modal-wrapper">
              <div className="block-modal-title">
                {localizations.resize[getLanguage()]}
              </div>
              <Gamemode onClick={closeModal} />
              <button className="block-modal-button" onClick={closeModal}>
                {localizations.close[getLanguage()]}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>,
    link
  );
};

export default GameoverModal;
